export { GlobalInfoBannerV2 } from './GlobalInfoBannerV2';
export { getBannerTheme, getBannerIcon } from './GlobalInfoBannerV2';
